export default __webpack_public_path__ + "static/thumbnail-12088c3fc5adb5a1dd854f0750652899.png";